import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

export const Sport = styled('div', { label: 'Sport' })`
    display: flex;
    flex-flow: column nowrap;
`;

interface EventsInPlayWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const EventsInPlayWrapper = styled('div', { label: 'EventsInPlayWrapper' })<EventsInPlayWrapperPropsType>`
    margin-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '8px': '0'};
`;

interface InPlayHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

export const InPlayHeader = withConfig(theme => styled('div', { label: 'InPlayHeader' })<InPlayHeaderPropsType>`
    display: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'flex': 'none'};
    height: 88px;
    padding: 16px;
    font-size: ${theme.star.fontSize.medium};
    font-weight: ${theme.star.fontWeight.bold};
    white-space: nowrap;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.big};
        padding: 24px;
    }
`);
